import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import "./Style.css";

export default function EditCredit({ showEdit, closeModal, refreshPage }) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: 1,
    customerName: "",
    duration: "",
    creditLine: "",
    startDate: "",
    endDate: "",
  });

  const resetForm = () => {
    setFormData({
      id: 1,
      customerName: "",
      duration: "",
      creditLine: "",
      startDate: "",
      endDate: "",
    });
    setValidationError({});
  };

  const handleChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulated successful submission
    handleClose();
    setIsLoading(false);
  };

  return (
    <div className="CreateCSP">
      <Modal show={showEdit} onHide={handleClose} dialogClassName="modal-md">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Credit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="categoryInput">
              <div className="input-group mb-2">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    {" "}
                    Customer Name &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                  </span>
                </div>
                <select
                  className="form-control custom-select"
                  name="customerName"
                  value={formData.customerName}
                  onChange={handleChange}
                >
                  <option value="">-- Select Customer --</option>
                  <option value="John Doe">John Doe</option>
                  <option value="Ajayi Sina">Ajayi Sina</option>
                  <option value="Dende Tobi">Dende Tobi</option>
                </select>
              </div>
              {validationError.customerName && (
                <small className="text-danger my-1">
                  {" "}
                  {validationError.customerName[0]}{" "}
                </small>
              )}
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <div>
                <h6>Price</h6>
              </div>
              <Form.Control
                type="number"
                placeholder="Enter..."
                name="creditLine"
                value={formData.creditLine}
                onChange={handleChange}
              />
              {validationError.creditLine && (
                <small className="text-danger my-1">
                  {validationError.creditLine[0]}
                </small>
              )}
            </Form.Group>
            {/* <Form.Group controlId="paymentTypeInput">
              <div className="input-group mb-2">
                <div className="input-group-prepend">
                  <span className="input-group-text"> Discount  &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp; </span>
                </div>
                <select
                  className="form-control custom-select"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                >
                  <option value="">-- Select Discount --</option>
                  <option value="5">5%</option>
                  <option value="10">10%</option>
                  <option value="20">20%</option>
                  <option value="50">50%</option>
                </select>
              </div>
              {validationError.discount && (
                <small className="text-danger my-1">
                  {" "}
                  {validationError.discount[0]}{" "}
                </small>
              )}
            </Form.Group> */}
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <div>
                <h6>Duration</h6>
              </div>
              <Form.Control
                type="text"
                placeholder="Enter..."
                name="duration"
                value={formData.duration}
                onChange={handleChange}
              />
              {validationError.duration && (
                <small className="text-danger my-1">
                  {validationError.duration[0]}
                </small>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="startDateInput">
              <div>
                <h6>Start Date</h6>
              </div>
              <Form.Control
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
              />
              {validationError.startDate && (
                <small className="text-danger my-1">
                  {validationError.startDate[0]}
                </small>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="endDateInput">
              <div>
                <h6>End Date</h6>
              </div>
              <Form.Control
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
              />
              {validationError.endDate && (
                <small className="text-danger my-1">
                  {validationError.endDate[0]}
                </small>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className=""
              style={{
                backgroundColor: "#c4281b",
                color: "#fff",
                border: "none",
              }}
              type="submit"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
